import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { appService } from '../../_services/app.service';
import { error } from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { DecryptPipe } from '../../auth/_services/encrypt-decrypt.pipe';
import { CookieService } from 'ngx-cookie-service';
import { CommonService } from '../../_services/common.service';
import { DriverService } from '../../shared/services/driver/driver.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Helpers } from '../../helpers';
import { Router } from '@angular/router';

// import { WalletComponent } from '../wallet.component';

declare const Cashfree: any;
@Component({
  selector: 'app-rechargeform',
  templateUrl: './rechargeform.component.html',
  styleUrls: ['./rechargeform.component.scss']
})
export class RechargeformComponent implements OnInit {
  selectedAmount: number | string;
  hostDomainUrl: any = environment.apiUrl;
  @Input() data: any = {};
  Balance: any;
  UserId: any;
  netwktypeId: any;
  orderId: any;
  UserEmailId: any;
  @Output() onSave = new EventEmitter<any>();
  static that: RechargeformComponent;

  constructor(
    private _appService: appService,
    private toastr: ToastrService,
    private decryptpipe: DecryptPipe,
    private cookieService: CookieService,
    private commonservice: CommonService,
    private driverservice: DriverService,
    private router: Router,
    private http: HttpClient
  ) {
    RechargeformComponent.that = this;
    // this.selectedAmount = this.data[this.RechargeAmount.dataField] || '';
  }

  // @ViewChild(WalletComponent) WalletComponent : WalletComponent;


  @Output() calllist = new EventEmitter<any>();

  @Output() onCloseEvent = new EventEmitter<any>();
  @Input() isMobileView: any;
  RechargeAmount: any;
  @Input() listOfField = [];
  TransactionId: any;
  Company: any;
  PaymentMethod: any;
  isFormSubmit: boolean = false;
  CompanyId: any;
  Date: any;
  UserFullName: any;
  @Output() modifiedValueOutput = new EventEmitter<any>();
  ngOnInit() {
    const networkTypeIds = this.commonservice.GetNetworkTypeIdsFromLocalStorage();
    this.netwktypeId = networkTypeIds[0];
    console.log(this.netwktypeId, 'netwktypeId')
    this.initializeform();
    this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
    this.UserId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.getWalletCount();
    this.GetCusotmers();
    this.GetPaymentMNode();
    this.UserEmailId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("EmailId")));
    this.UserFullName = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserFullName")));

  }

  initializeform() {
    this.RechargeAmount = {
      lable: "Recharge Amount",
      placeholder: "Enter Recharge Amount",
      dataField: 'Amount',
      formControlName: 'Amount',
      type: 'number',
      isRequired: true,
    };
    this.TransactionId = {
      lable: "TransactionId",
      placeholder: "Enter TransactionId",
      dataField: 'TransactionId',
      formControlName: 'TransactionId',
      type: 'text',
    };
    this.Company = {
      lable: "Company",
      placeholder: "Select Company",
      dataField: 'NetWorktypeId',
      formControlName: 'NetWorktypeId',
      isValueBind: true
    };
    this.Date = {
      lable: 'Date',
      dataField: 'Date',
      formControlName: 'Date',
      placeholder: 'Date'
    };
    this.PaymentMethod = {
      lable: "PaymentMethod",
      placeholder: "Select PaymentMethod",
      dataField: 'PaymentMethod',
      formControlName: 'PaymentMethod',
      isValueBind: true
    };
  }

  close() {
    this.onCloseEvent.emit();
  }
  getChangedValue(value, dataFeild) {
    this.data[dataFeild] = value;
    this.modifiedValueOutput.emit({ value, dataFeild })
    console.log("getchanged", value, dataFeild);
    // this.data[dataFeild] = value;
    console.log(this.data, 'Data')
  }
  selectAmount(amount: number) {
    this.selectedAmount = amount;
    this.getChangedValue(amount, this.RechargeAmount.dataField);
  }
  isFormInValid() {
    return this.listOfField.some(item => item.some(x => x.isRequired && !this.data[x.dataField]));
  }
  onSaveBtnClick() {
    this.isFormSubmit = true
    if (!this.data.hasOwnProperty('Amount') || this.data.Amount == null) {
      this.toastr.error('Required field');
      return;
    }
    this.onSave.emit(this.data);
    this.close();
  }
  getWalletCount() {
    this._appService.GetByTwoParam('OrdersByVehicle', 'GetWalletCount', this.CompanyId, this.UserId).subscribe(
      (response) => {
        console.log(response)
        if (response.length > 0) {
          this.Balance = response[0].Balance
        }

      },
      (err) => {
        console.log(err)
        this.toastr.error(err, 'Error')
      }
    )
  }
  GetCusotmers() {
    this._appService
      .Get("OrdersByVehicle", "GetcustomerListNEw")
      .subscribe(
        (response) => {
          if (response) {
            response.map(x => {
              x.name = x.Label;
              x.value = x.Id;

            })
          }
          this.Company = { ...this.Company, dropdownList: response };
        },
        (err) => {
        }
      );
  }
  GetPaymentMNode() {
    this._appService
      .GetById("Common", "GetLookByCategoryName", "PaymentTypeMode")
      .subscribe(
        (response) => {
          if (response) {
            response.map(x => {
              x.name = x.Label;
              x.value = x.Label;

            })
          }
          this.PaymentMethod = { ...this.PaymentMethod, dropdownList: response };
        },
        (err) => {
        }
      );
  }
  get dialogClass() {
    return this.netwktypeId ? 'dialog-large-margin' : 'dialog-small-margin';
  }


  initiatePayment() {

    Helpers.setLoading(true);

    const currentUrl = this.router.url;
    const order = {
      orderId: '121',
      orderAmount: this.data.Amount,
      orderNote: '',
      customerName: this.UserFullName,
      customerPhone: '+917887696941',
      customerEmail: this.UserEmailId,
      customerId: this.UserId,
      returnUrl: currentUrl
    };

    this.http.post<{ PaymentSessionId?: string, OrderId?: string }>(`${this.hostDomainUrl}/api/OrdersByVehicle/InitiatePayment`, order)
      .subscribe({
        next: (response) => {
          if (response && response.PaymentSessionId && response.OrderId) {
            RechargeformComponent.that.orderId = response.OrderId;

            localStorage.removeItem('currentOrderId');
            localStorage.setItem('currentOrderId', RechargeformComponent.that.orderId);

            const cashfree = Cashfree({
              mode: 'sandbox'
            });

            cashfree.checkout({
              paymentSessionId: response.PaymentSessionId,
              amount: this.data.Amount,
              redirectTarget: '_self'
            });
            this.calllist.emit();
          } else {
            console.error('Unexpected response format:', response);
          }
          Helpers.setLoading(false);
        },
        error: (error) => {
          console.error('Error initiating payment:', error);
          Helpers.setLoading(false);
        }
      });
  }


  checkPaymentStatus() {

    const orderId = localStorage.getItem('currentOrderId');
    if (orderId) {
      this._appService.GetByFourId('OrdersByVehicle', 'GetPaymentStatus_cashfree', orderId, this.CompanyId, this.netwktypeId, this.UserId).subscribe(
        (response) => {
          console.log('Payment status:', response);
          localStorage.removeItem('currentOrderId');
        },
        (err) => {
          console.error('Error checking payment status:', err);
        }
      );
    }
    Helpers.setLoading(false);
  }

}

